export default __webpack_public_path__ + "static/media/the_fool.47c04411.png";